import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, Route, Switch, useHistory, withRouter} from 'react-router-dom';
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import DepartmentContent from "../../../components/department/front/detail/content";
import DepartmentSide from "../../../components/department/front/detail/side";
import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/departments";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";

import {BASE_PATH} from "../../../wpconfig";

class Department extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'department'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		this.getDetail();
	}

	componentWillUnmount(){
		this.setState = (state, callback) => {
			return;
		}
	}

	getDetail() {
		func.getData(this.state.action + "/" + func.getParams("record_id"), null).then((response) => {
			this.props.dataActions.setDepartment(response);
			this.setState({
				isInit: true,
			})

			func.getData(this.state.action + "/" + func.getParams("record_id") + "/stats", {}).then((response) => {
				if (response && response.length > 0) {
					let payload = {};
					payload.stats = response.record;
					this.props.dataActions.setDepartment(payload);
				}
			});
		});
	}

	render() {
		const {isInit} = this.state;

		return (
			<div className="contents-group">
				{!isInit ? <div className="m-auto m-0"><Loading/></div> :
					<>
						<DepartmentContent/>
						<DepartmentSide/>
					</>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		// record: state.departments.record ? state.departments.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Department)

Department.propTypes = {
	record: PropTypes.object,
};
